export default "__VITE_ASSET__CJiK13Ys__"